import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('portal.gsdcadmin.community.group.user');
import { OnInit, OnDestroy, Input } from '@angular/core';
import { Service } from "src/libs/portal/season/service";
import { Router } from '@angular/router'

@Component({
    selector: 'wiz-portal-gsdcadmin-community-group-user',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/portal.gsdcadmin.community.group.user/view.scss */
/* src/app/portal.gsdcadmin.community.group.user/view.scss: no such file or directory */`],
})
export class PortalGsdcadminCommunityGroupUserComponent implements OnInit, OnDestroy {

    constructor(@Inject( Service) public service: Service,@Inject( Router)  private router: Router) { }

    @Input() community_id: any;
    @Input() group_id: any;
    public users: any = [];
    public community: any = {};
    public group: any = {};

    public pagination: any = {
        page: 1,
        start: 1,
        end: 1
    }
    public searchTerm = "";
    public total = 0;

    public async ngOnInit() {
        await this.service.init();
        await this.load();
    }

    public async load() {
        const { code, data } = await wiz.call("load", { text: this.searchTerm, page: this.pagination.page, communityID: this.community_id, groupID: this.group_id });
        if (code != 200) return await this.service.alert.error("Error!");
        this.users = data.users;
        this.community = data.community;
        this.group = data.group;
        this.pagination.start = Math.floor((this.pagination.page - 1) / 10) * 10 + 1;
        this.pagination.end = data.lastpage;
        this.total = data.total;
        await this.service.render();
    }

    private async pageLoad(p: number) {
        this.pagination.page = p;
        await this.load();
    }

    public async changePI(user: any, event: Event) {
        const checkbox = event.target as HTMLInputElement;

        const original = user.representative;              // 'Y' 또는 'N' (기존 상태)
        const next = checkbox.checked ? 'Y' : 'N';         // 클릭 후 상태

        // UI에 먼저 반영
        user.representative = next;
        await this.service.render();

        let res: any;
        if (next === 'Y') {
            res = await this.service.alert.show({
                title: "PI 지정",
                message: "해당 사용자를 PI로 지정하시겠습니까?",
                action: "지정",
                cancel: "취소",
                actionBtn: 'success',
                status: 'success'
            });
        } else {
            res = await this.service.alert.show({
                title: "PI 해제",
                message: "해당 사용자를 PI에서 해제하시겠습니까?",
                action: "해제",
                cancel: "취소",
                actionBtn: 'error',
                status: 'error'
            });
        }

        // 취소 눌렀을 때 → 원복
        if (res !== true) {
            user.representative = original;
            await this.service.render();
            return;
        }

        // 서버 호출
        const { code } = await wiz.call("changePI", {
            user: JSON.stringify(user),
            group: JSON.stringify(this.group)
        });

        // 실패 시에도 원복
        if (code !== 200) {
            user.representative = original;
            await this.service.render();
            return;
        }

        await this.service.alert.success("PI 지정/해제 완료했습니다.");
    }
}

export default PortalGsdcadminCommunityGroupUserComponent;